// Clave pública de prueba de Google: el widget siempre aprueba. Solo para desarrollo local.
const RECAPTCHA_TEST_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
const RECAPTCHA_SITE_KEY = '6LdoDqotAAAAADXHJ4PuZKLUjsDMWvnAfGytJt8R';

const local = {
  reCaptchaSiteKey: RECAPTCHA_TEST_SITE_KEY,
  gaMeasurementId: '',
  url: {
    api: "https://api.labs.mapseguros.cl"
  }
};

const dev = {
  reCaptchaSiteKey: RECAPTCHA_SITE_KEY,
  gaMeasurementId: '',
  url: {
    api: "https://api.labs.mapseguros.cl"
  }
};

const prod = {
  reCaptchaSiteKey: RECAPTCHA_SITE_KEY,
  gaMeasurementId: 'G-36L7QV5SYY',
  url: {
    api: "https://api.mapseguros.cl"
  }
};

const env = (process.env.REACT_APP_ENV || '').trim();

const config = env === 'production' ? prod : env === 'development' ? dev : local;

export default config;



// WEBPACK FOOTER //
// ./src/config.js